'use client';

import type { ShopperProducts } from '@/scapi';
import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { GIFT_CARD_DETAILS_TAB_ID } from './index';

const TAB_TRIGGER_CLASSNAME =
    'label-m shrink-0 bg-sand-95 text-neutral-10 rounded-full hover:bg-neutral-10 hover:text-neutral-white data-[state=active]:bg-neutral-10 data-[state=active]:text-neutral-white md:flex-none md:w-fit';

/**
 * Fallback gift card tabs when no Page Designer configuration is present.
 * Shows Dettagli with product long description only.
 */
export default function GiftCardProductTabsFallback({
    product,
}: {
    product: ShopperProducts.schemas['Product'];
}): ReactElement {
    const { t } = useTranslation('product');
    const productDescription = product.longDescription;

    return (
        <Tabs
            defaultValue={GIFT_CARD_DETAILS_TAB_ID}
            className="gap-8 max-w-screen-2xl mx-auto w-full min-w-0"
            data-testid="gift-card-product-tabs-fallback">
            <TabsList
                scrollActiveTabOnMobile
                className="flex w-full max-w-full min-w-0 bg-transparent gap-3 overflow-x-auto scrollbar-hide overflow-y-hidden px-0 justify-start">
                <TabsTrigger value={GIFT_CARD_DETAILS_TAB_ID} className={TAB_TRIGGER_CLASSNAME}>
                    {t('tabs.details.title')}
                </TabsTrigger>
            </TabsList>
            <TabsContent value={GIFT_CARD_DETAILS_TAB_ID} className="w-full">
                <div className="grid grid-cols-12 gap-4 lg:justify-between">
                    <div className="col-span-12 lg:col-span-7">
                        {productDescription ? (
                            <div
                                className="prose prose-sm max-w-none marker:text-black [&_ul]:list-disc [&_ul]:pl-5 body-copy-l text-neutral-10"
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{ __html: productDescription }}
                            />
                        ) : null}
                    </div>
                </div>
            </TabsContent>
        </Tabs>
    );
}
